export enum SmartTeamsAppUserGroup {
  Admin = 'Admin',
  FieldEngineer = 'FieldEngineer',
  Customer = 'Customer',
  PartnerManager = 'PartnerManager',
}
